import { createContext } from "react"
const { REACT_APP_NETWORK_PROVIDER, REACT_APP_NETWORK } = process.env
const networkEnv = REACT_APP_NETWORK || "ALGO"
const providerEnv = REACT_APP_NETWORK_PROVIDER || "TestNet"
export const context = {
  networkEnv,
  providerEnv,
}
export const AppContext = createContext(context)